import styled from 'styled-components';

export const PriceList = styled.div`
  display: flex;
  flex-direction: column;
`